import { render } from "./PerformanceComparison.vue?vue&type=template&id=2aa09450&scoped=true"
import script from "./PerformanceComparison.vue?vue&type=script&lang=js"
export * from "./PerformanceComparison.vue?vue&type=script&lang=js"

import "./PerformanceComparison.vue?vue&type=style&index=0&id=2aa09450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa09450"]])

export default __exports__